import { upArrow, setOffsetHeight } from './animations.js';
import { mobileNavigation } from './mobileNavigation.js';
import { gravityForms } from './gravityforms.js';

upArrow();
setOffsetHeight();
gravityForms();
mobileNavigation();

//Hiermee stellen we een CSS variabele in, aan de bovenkant van de pagina. Hierdoor is de offset bovenaan de pagina correct.
// De scroll-padding staat dan in de CSS GLOBAL.SCSS: 
const navigationHeight = document.querySelector('header.wp-block-template-part').offsetHeight;
// console.log(navigationHeight);
document.documentElement.style.setProperty('--scroll-padding', navigationHeight - 1 + 'px');

// Om op de pagina te blijven moet de modal van de pagina af bij mobiel gebruik:
// const navigationlinks = document.querySelectorAll('.wp-block-navigation-item__content');
// navigationlinks.forEach(function () {
//     let modal = document.querySelector('wp-block-navigation__responsive-container');
//     modal.classList.remove('is-menu-open has-modal-open')
// });

 